import React, { useCallback, useEffect, useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { checkoutLogin, getTokenTenantId } from '@yuanfudao/metis-unified-login'
import config from '@/config/index'

import { useGlobalHox } from '@/hox/global'

import { TEACHER_INFO_MENU_ITEMS } from '@/constants/login'

import defaultAvartar from '@/assets/common/default-avatar.png'
import { useRecoilValue } from 'recoil'
import { currentAccountAtom } from '@/store/home'
import lessModule from './index.module.less'

import TeacherInfoMenu from './menu'

export default function NavBar(props: any) {
  const navigate = useNavigate()
  const location = useLocation()
  const currentAccount = useRecoilValue(currentAccountAtom)
  const { teacherInfo: { accountAvartar } } = useGlobalHox()
  // 个人信息、管理菜单
  const [manageInfoMenuArr, setManageInfoMenuArr] = useState<TEACHER_INFO_MENU_ITEMS[]>([TEACHER_INFO_MENU_ITEMS.LOGOUT])
  const [showManageInfoMenuArr, setShowManageInfoMenuArr] = useState(false)

  const clickShowManageInfoMenuArr = useCallback((e) => {
    e.nativeEvent.stopImmediatePropagation()
    setShowManageInfoMenuArr(!showManageInfoMenuArr)
  }, [showManageInfoMenuArr])

  const handleClickLogo = () => {
    const tenantId = getTokenTenantId()
    if (location.pathname.includes('/embed') && (!tenantId || String(tenantId) === '-1')) {
      return
    }
    if (location.pathname !== '/home') {
      navigate('/home')
    }
  }

  const clearMenu = () => {
    setShowManageInfoMenuArr(false)
  }

  const goLogin = () => {
    checkoutLogin()
  }

  useEffect(() => {
    setShowManageInfoMenuArr(false)
    document.addEventListener('click', clearMenu)
    return () => {
      document.removeEventListener('click', clearMenu)
    }
  }, [props.location])

  return (
    <div className={lessModule.navbar}>
      <div className={lessModule.logo} onClick={handleClickLogo} />
      {
        currentAccount ? (
          <div className={lessModule.subjectandInfo}>
            <div className={lessModule.headPhoto} onClick={clickShowManageInfoMenuArr}>
              <img src={`${accountAvartar ? `${config.AVATAR_PREFIX}${accountAvartar}` : defaultAvartar}`} alt="" />
            </div>
            <div className={lessModule.teacherName} onClick={clickShowManageInfoMenuArr}>
              { `${currentAccount?.tenantName ?? ''}临时账号` }
            </div>
            {showManageInfoMenuArr && <TeacherInfoMenu menuArr={manageInfoMenuArr} />}
          </div>
        ) : (
          <div className={lessModule.login} onClick={goLogin}>登录</div>
        )
      }
    </div>
  )
}
